export const GetflyApiKey = { 'X-API-Key': '9HzV4BkrWu26Qj6YPIbRPLvvp2kkbQ' };
